module.exports = __webpack_public_path__ + "static/img/home-market.f3e6c23b.png";